/**
 * Valid, deterministic demo mobiles for the seed (75n7). Several generators used
 * to build numbers from id letters or one digit too many ("+61 4i11 111 111",
 * "+61 4010 001 007"), which fail the mobile check, break duplicate detection and
 * can't be dialled in a demo. Every number here is an Australian mobile,
 * "+61 4SS NNN NNN": SS is the generator's own series (so two generators never
 * collide) and NNN NNN its sequence number.
 */
function format(series: number, n: number): string {
  const ss = String(series).padStart(2, '0');
  const six = String(n % 1_000_000).padStart(6, '0');
  return `+61 4${ss} ${six.slice(0, 3)} ${six.slice(3)}`;
}

/** The `n`th mobile of a generator's series (unique while n < 1,000,000). */
export function seedMobile(series: number, n: number): string {
  return format(series, n);
}

/** A stable mobile for a record keyed by a string id (FNV-1a, into the series). */
export function seedMobileFor(series: number, key: string): string {
  let h = 0x811c9dc5;
  for (let i = 0; i < key.length; i += 1) {
    h ^= key.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return format(series, h % 1_000_000);
}
